import { connect } from 'react-redux'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import { downloadCsv } from './actions'
import ProjectTrackerExportButton from './components/ProjectTrackerExportButton'

const mapStateToProps = (state) => {
  const { projectTrackerFilters } = state
  return { projectTrackerFilters }
}

const mapDispatchToProps = (dispatch) => {
  return {
    downloadCsv: (leads) => dispatch(downloadCsv(leads)),
  }
}

const LeadListQuery = gql`
  query LeadList {
    leads(status: CLOSED) {
      id
      status
      projectName
      developerName
      units
      clientType
      closedAt
      closingOutcome
      closingReasons
    }
  }
`

const ComponentWithData = graphql(LeadListQuery, {
  options: { forceFetch: true },
})(ProjectTrackerExportButton)

const connector = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ComponentWithData)
export default connector
